enum PublicTime {
  WEEKS2 = "WEEKS2",
  WEEKS4 = "WEEKS4",
  WEEKS8 = "WEEKS8",
}

export default PublicTime;
